import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/suggestions`;

const BookSuggestionManager = {
  /**
   * Create a new book suggestion
   * @param {Object} suggestionData
   * @returns {Promise<Object>} created BookSuggestDTO
   */
  async createSuggestion(suggestionData) {
    const response = await axios.post(`${BASE_URL}/add`, suggestionData); // ✅ correct path
    return response.data.responseData;
  },
};

export default BookSuggestionManager;

